/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaContractVerifyInfo = {
    STS: SomniaContractVerifyInfo.STS;
    CTRTADDR: string;
    MSG: string;
    VA: number;
    NM: string;
    BTCD: string;
    ABI: string;
};

export namespace SomniaContractVerifyInfo {

    export enum STS {
        Y = 'Y',
        N = 'N',
    }


}

